import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Who I Help',
    href: '#who-i-help'
  }, {
    name: 'My Story',
    href: '#my-story'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Podcast',
    href: '#podcast'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark-darker/95 backdrop-blur-sm py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="flex justify-between items-center" data-id="element-89">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer flex items-center gap-3" onClick={() => window.scrollTo(0, 0)} data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/chtLiN7NP86jg8BJETW5iX/mike-curry-logo.png" alt="Mike Curry Coaching" className="h-16 w-auto" data-id="element-91" />
            <span className="font-heading text-xl text-white tracking-wide hidden sm:block" data-id="element-92">
              Mike Curry Coaching
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-93">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-300 hover:text-gold transition-colors text-sm uppercase tracking-wider font-medium" data-id="element-94">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-gold hover:bg-gold-light text-black font-bold py-2 px-6 rounded-sm uppercase tracking-wide transition-all transform hover:scale-105" data-id="element-95">
              Book a Strategy Session
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-96">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-gold transition-colors p-2" aria-label="Toggle menu" data-id="element-97">
              {isMobileMenuOpen ? <X size={28} data-id="element-98" /> : <Menu size={28} data-id="element-99" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      <AnimatePresence data-id="element-100">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark-darker border-t border-dark-lighter overflow-hidden" data-id="element-101">
            <div className="px-4 pt-4 pb-8 space-y-4 flex flex-col items-center" data-id="element-102">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-gray-300 hover:text-gold text-lg uppercase tracking-wider font-medium py-2" data-id="element-103">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 bg-gold hover:bg-gold-light text-black font-bold py-3 px-8 rounded-sm uppercase tracking-wide w-full text-center" data-id="element-104">
                Book a Strategy Session
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}